export const SUCCESS_STATUS = "SUCCESS";
export const FAILURE_STATUS = "FAILURE";
export const DEFAULT_ERROR_MSG = "Something went wrong";
export const BICYCLE_COMPANY_EMAIL = "pixiemartindia@gmail.com";

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.mart.pixie.twister.tongue';
export const APP_STORE_URL = 'https://apps.apple.com/in/app/pixie-mart-twister/id6472185557';
